import { Link, styled } from '@mui/material';
import { IconExport } from 'assets/img';
import { useGetShiftPlanningUrl } from '../hooks/use-get-shift-planning-url';

type ShiftPlanningLinkProps = {
  shiftId: string;
  utcStartDateTime: string;
  children: React.ReactNode;
};

export const ShiftPlanningLink = ({
  shiftId,
  utcStartDateTime,
  children,
}: ShiftPlanningLinkProps) => {
  const getShiftPlanningUrl = useGetShiftPlanningUrl();

  return (
    <StyledLink
      href={getShiftPlanningUrl(shiftId, utcStartDateTime)}
      target="_blank"
      rel="noopener noreferrer"
      color="inherit"
      underline="hover"
    >
      {children}
      <IconExport aria-hidden />
    </StyledLink>
  );
};

const StyledLink = styled(Link)(({ theme }) => ({
  display: 'inline-flex',
  alignItems: 'center',
  gap: theme.spacing(1),
  color: theme.palette.lwPrimaryAccentDark[100],
  '&:visited': {
    color: theme.palette.lwPrimaryAccentDark[100],
  },
  '& svg': {
    flexShrink: 0,
    width: theme.spacing(5),
    height: theme.spacing(5),
  },
  '& svg path': {
    stroke: 'currentColor',
  },
}));
